/**
 * Grid de N metric cards horizontais.
 */
import { ReactNode } from 'react'

export type MetricCardData = {
  icon: any
  label: string
  value: string | number
  subtitle?: string
  color?: string
}

export default function MetricCardGrid({ cards }: { cards: MetricCardData[] }) {
  const cols = cards.length === 2 ? 'sm:grid-cols-2'
             : cards.length === 4 ? 'sm:grid-cols-2 lg:grid-cols-4'
             : 'sm:grid-cols-3'
  return (
    <div className={`grid grid-cols-1 ${cols} gap-4`}>
      {cards.map((c, i) => <MetricCard key={i} {...c} />)}
    </div>
  )
}

function MetricCard({ icon: Icon, label, value, subtitle, color }: MetricCardData) {
  const c = color || '#06b6d4'
  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-5">
      <div className="flex items-start justify-between mb-2">
        <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">{label}</p>
        {Icon && <Icon className="h-5 w-5" style={{ color: c }} />}
      </div>
      <p className="text-xl font-bold" style={{ color: c }}>{value}</p>
      {subtitle && <p className="text-xs text-slate-400 mt-1 leading-relaxed">{subtitle}</p>}
    </div>
  )
}
